import { RouterProvider } from 'react-router-dom';
import { router } from './router';

/**
 * Root application component that provides the router.
 */
function App() {
  return <RouterProvider router={router} />;
}

export default App;
